import { useEffect, useState } from "react";
import { isNativeApp } from "@/lib/platform";

// Règle Entrée du chat (façon WhatsApp) : sur téléphone / tablette (app native ou pointeur tactile),
// Entrée va à la ligne et l'envoi se fait au bouton ; sur PC, Entrée envoie et Maj+Entrée va à la ligne.
export const enterSendsNow = () => {
  if (isNativeApp()) return false;
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return !window.matchMedia("(pointer: coarse)").matches;
};

export function useEnterSends() {
  const [v, setV] = useState(enterSendsNow);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia("(pointer: coarse)");
    const on = () => setV(enterSendsNow());
    mql.addEventListener?.("change", on);
    return () => mql.removeEventListener?.("change", on);
  }, []);
  return v;
}
